import { useMutation } from '@tanstack/react-query';

import { exercisesService } from '../services';
import type { RequestExerciseThumbnailUploadUrlInput } from '../types';

/**
 * Step 1 of the exercise thumbnail upload — request a presigned S3 PUT.
 *
 * The BE writes the derived key onto the exercise row in the same transaction,
 * so after the PUT succeeds the caller invalidates the exercise detail query to
 * pick up the fresh `thumbnailDownloadUrl`. No follow-up PATCH.
 */
export function useRequestExerciseThumbnailUploadUrl() {
  return useMutation({
    mutationFn: (input: RequestExerciseThumbnailUploadUrlInput) =>
      exercisesService.requestThumbnailUploadUrl(input),
  });
}
